module.exports = __webpack_public_path__ + "static/img/qr.3cc4ef.png";